/**
 * Stable CSS class names for E2E — Lost cargo search / return list page.
 */
export const LCSR = {
    page: 'lost-cargo-search-return-page',
    loadingSection: 'lost-cargo-search-return-page__loading-section',
    breadcrumbWrap: 'lost-cargo-search-return-page__breadcrumb-wrap',

    summaryCard: 'lost-cargo-search-return-summary-card',
    summaryCardHeader: 'lost-cargo-search-return-summary-card__header',
    summaryCardTitle: 'lost-cargo-search-return-summary-card__title',
    linkTrackingCarrier: 'lost-cargo-search-return-summary-card-input--link-tracking-carrier',
    summaryCarrierChip: 'lost-cargo-search-return-summary-card__carrier-chip',
    summaryStatusChip: 'lost-cargo-search-return-summary-card__status-chip',
    emptyListMessage: 'lost-cargo-search-return-page__empty-list-message',

    searchFormRoot: 'lost-cargo-search-return-search-form',
    searchFormContentWrap: 'lost-cargo-search-return-search-form__content-wrap',
    searchFormCompositeWrap: 'lost-cargo-search-return-search-form__composite-wrap',
    searchFormComposite: 'lost-cargo-search-return-search-form-input--composite-search',
    searchFormSelectType: 'lost-cargo-search-return-search-form-input--select-search-type',
    searchFormTextQuery: 'lost-cargo-search-return-search-form-input--text-query',
    searchFormButtonSearch: 'lost-cargo-search-return-search-form-input--button-search',

    infoCard: 'lost-cargo-search-return-info-card',
    infoCardGrid: 'lost-cargo-search-return-info-card__grid',
    infoRow: 'lost-cargo-search-return-info-card__row',
    infoLabel: 'lost-cargo-search-return-info-card__label',
    infoValue: 'lost-cargo-search-return-info-card__value',
    linkCustomerManagement: 'lost-cargo-search-return-info-card-input--link-customer',
    linkShippingList: 'lost-cargo-search-return-info-card-input--link-shipping-list',
    linkOrderDetail: 'lost-cargo-search-return-info-card-input--link-order',

    gridOuter: 'lost-cargo-search-return-grid__outer',
    gridPaper: 'lost-cargo-search-return-grid__paper',

    imagePreviewDialogPaper: 'lost-cargo-search-return-image-preview-dialog',
    inputIconImagePreviewClose: 'lost-cargo-search-return-image-preview-dialog-input--icon-close',
    imagePreviewContent: 'lost-cargo-search-return-image-preview-dialog__content',
    imagePreviewImg: 'lost-cargo-search-return-image-preview-dialog__img',

    productsTableContainer: 'lost-cargo-search-return-products-table',
    productsTable: 'lost-cargo-search-return-products-table__table',
    productRow: 'lost-cargo-search-return-products-table__row',
    productImageCell: 'lost-cargo-search-return-products-table__image-cell',
    productImageWrap: 'lost-cargo-search-return-products-table__image-wrap',
    inputIconProductImageZoom: 'lost-cargo-search-return-products-table-input--icon-zoom',
    productBarcodeCell: 'lost-cargo-search-return-products-table__barcode-cell',
    linkProductDetail: 'lost-cargo-search-return-products-table-input--link-product-detail',
    inputSelectRowReturnReason: 'lost-cargo-search-return-products-table-input--select-return-reason',
    inputSelectRowQuantity: 'lost-cargo-search-return-products-table-input--select-quantity',
    tableFooterSummary: 'lost-cargo-search-return-products-table__footer-summary',
    inputButtonCreateReturnRequest: 'lost-cargo-search-return-grid-input--button-create-return-request',
} as const;

export const lcsrCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
